export default {
    meta: {
        title: '跟进记录',
        url: '/standardstore/chancepointlist',
        urlName: '标准版拓店-机会点',
    }
};
